import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// 404
const Page404 = () => import('@/views/pages/Page404');

// Projects
const Projects = () => import('@/views/projects/Index');
const Project = () => import('@/views/projects/Show');
const ProjectCreate = () => import('@/views/projects/Create');

// Projects Updates
const ProjectUpdate = () => import('@/views/projects/updates/Show');

// Project introductions
const ProjectIntroductions = () => import('@/views/project-introductions/Index');
const ProjectIntroduction = () => import('@/views/project-introductions/Show');

// Admins
const Users = () => import('@/views/users/Index');
const User = () => import('@/views/users/Show');

// Contacts
const Contacts = () => import('@/views/contacts/Index');
const Contact = () => import('@/views/contacts/Show');

// News
const News = () => import('@/views/news/Index');
const NewsSingle = () => import('@/views/news/Show');

// Frequently Asked Questions
const FAQ = () => import('@/views/frequentlyaskedquestions/Index');
const FAQSingle = () => import('@/views/frequentlyaskedquestions/Show');

// Accounts
const Accounts = () => import('@/views/accounts/Index');
const Account = () => import('@/views/accounts/Show');

// Accounts
const PortalUsers = () => import('@/views/portal-users/Index');
const PortalUser = () => import('@/views/portal-users/Show');

// Groups
const Groups = () => import('@/views/groups/Index');
const Group = () => import('@/views/groups/Show');

// Profile
const Profile = () => import('@/views/profile/Show');

// Login
const Login = () => import('@/views/login/Login');
const PasswordForgot = () => import('@/views/login/PasswordForgot');
const PasswordReset = () => import('@/views/login/PasswordReset');
const ActivateAccount = () => import('@/views/login/ActivateAccount');

const Dashboard = () => import('@/views/pages/Dashboard');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/admin',
      name: 'admin',
      redirect: 'admin/dashboard',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
        },
        {
          path: 'projects',
          name: 'projects',
          component: Projects,
        },
        {
          path: 'projects/toevoegen',
          name: 'projects.create',
          component: ProjectCreate,
        },
        {
          path: 'projects/:id',
          name: 'projects.view',
          component: Project,
        },
        {
          path: 'projects/:id/updates/:update_id',
          name: 'projects.updates.view',
          component: ProjectUpdate,
        },
        {
          path: 'project-introductions',
          name: 'project-introductions',
          component: ProjectIntroductions,
        },
        {
          path: 'project-introductions/:id',
          name: 'project-introductions.view',
          component: ProjectIntroduction,
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
        },
        {
          path: 'users/:id',
          name: 'users.view',
          component: User,
        },
        {
          path: 'accounts/contacts',
          name: 'contacts',
          component: Contacts,
        },
        {
          path: 'accounts/contacts/:id',
          name: 'contacts.view',
          component: Contact,
        },
        {
          path: 'accounts',
          name: 'accounts',
          component: Accounts,
        },
        {
          path: 'accounts/:id',
          name: 'accounts.view',
          component: Account,
        },
        {
          path: 'news',
          name: 'news',
          component: News,
        },
        {
          path: 'news/:id',
          name: 'news.view',
          component: NewsSingle,
        },
        {
          path: 'faq',
          name: 'faq',
          component: FAQ,
        },
        {
          path: 'faq/:id',
          name: 'faq.view',
          component: FAQSingle,
        },
        {
          path: 'portal-users',
          name: 'portal-users',
          component: PortalUsers,
        },
        {
          path: 'portal-user/:id',
          name: 'portal-users.view',
          component: PortalUser,
        },
        {
          path: 'groups/index',
          name: 'groepen',
          component: Groups,
        },
        {
          path: 'groups/:id',
          name: 'groups.view',
          component: Group,
        },
      ],
    },
    {
      path: '/',
      name: 'login-main',
      redirect: '/login',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: PasswordForgot,
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: PasswordReset,
        },
        {
          path: 'activate-account',
          name: 'activate-account',
          component: ActivateAccount,
        },
      ],
    },
    {
      path: '*',
      component: Page404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  if (to.fullPath.includes('admin')) {
    if (!store.state.accessToken) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (store.state.accessToken) {
      next('/admin');
    }
  }
  next();
});

export default router;
